import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import GridCard from '../GridCard/GridCard';
import DoughnutGraph from '../DoughnutGraph/DoughnutGraph';

const DoughnutInGridCardWithHeader = ({ header, data }) => (
    <GridCard xs={12} sm={6} xl={3}>
        <Typography gutterBottom variant="h6" component="h3">
            {header}
        </Typography>
        <DoughnutGraph graphData={data} />
    </GridCard>

);
DoughnutInGridCardWithHeader.propTypes = {
    header: PropTypes.string.isRequired,
    data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default DoughnutInGridCardWithHeader;
